
  import createMeisterIcons from '../src/createMeisterIcons';

  const SwitchActive = createMeisterIcons("switch-active", [["path",{"fill":"currentColor","d":"M8 7.75c-2.386 0-4.25 1.864-4.25 4.25 0 2.296 1.874 4.25 4.25 4.25h8c2.386 0 4.25-1.864 4.25-4.25S18.386 7.75 16 7.75zM2.25 12c0-3.214 2.536-5.75 5.75-5.75h8c3.214 0 5.75 2.536 5.75 5.75s-2.536 5.75-5.75 5.75H8c-3.224 0-5.75-2.646-5.75-5.75M16 9.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5","key":"ed124643489a09b09b9b793569524167c996260c","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default SwitchActive
  